var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#facc14;stroke:#000;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-60.5,18.5C829.1,183.54,1015.8,317.87,1015.5,411.5c-.72,229.25-1124.54,303.61-1141,614-16.81,316.93,1102.03,657.19,1063,761-3.93,10.45-17.99,14.27-32,17-270.99,52.89-715.63-261.84-1039-612-85.53-92.61-154.68-178.4-136-268,20.22-97.04,133.41-151.17,256-200,531.38-211.66,895.17-187.75,912-283,13.72-77.69-211.06-186.6-352-237C189.25,75.74-131.64,144.25-141.5,86.5c-1.97-11.57,7.86-32.11,81-68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMobile);
export default __webpack_public_path__ + "static/media/orange_mobile.af160c6bb1c087a872ddb9897b38521d.svg";
export { ForwardRef as ReactComponent };